/* eslint-disable react/no-danger -- Rich text is sanitized with DOMPurify before rendering. */
import React from 'react';
import { connect, history } from 'umi';

import DOMPurify from 'dompurify';
import { Text, Button } from '@digitalc/dxp-ui';
import { onHistoryPush, getThemeImgByKey } from '@/utils/utils';
import useGCPI18n from '@/hooks/useGCPI18n';
import convertSuccess from '@/assets/images/point/point_success_page.png';
import styles from './index.less';

const SuccessPage = props => {
  const { dxpToken, pbPageCode, product, userDimension } = props;

  const { title, content, btnText } = history?.location?.state || {};
  const { ATPSUCC_REDIRECT_MENU_CODE } = history.location.query;

  const GCPI18n = useGCPI18n();

  // 优先从 store 读取，如果为空则从 localStorage 兜底（防止页面刷新后 store 重置）
  const effectivePbPageCode = pbPageCode || window.localStorage.getItem('GCP_POINT_HOME_PAGE_CODE');

  return (
    <div className={styles.successPage}>
      <div className={styles.imgWrap}>
        <img src={getThemeImgByKey('genericSuccess') || convertSuccess} alt="" />
      </div>

      <Text
        breakpoint="Mobile"
        size="ContentC23Bold"
        style={{ marginBottom: '0.08rem', color: dxpToken.colorTextHeaderHighlight }}
      >
        {title || GCPI18n({ id: 'lb_successful_redeem_successful' })}
      </Text>
      {/* <Text breakpoint="Mobile" size="ContentC14Regular">
        {content || GCPI18n({ id: 'lb_points_redeem_success_tip' })}
      </Text> */}
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(content || GCPI18n({ id: 'lb_points_redeem_success_tip' })),
        }}
      />

      <Button
        block
        type="primary"
        onClick={() => {
          if (ATPSUCC_REDIRECT_MENU_CODE) {
            const jumpObj = {
              url: `/clp_tabPage/index?menuCode=${ATPSUCC_REDIRECT_MENU_CODE}`,
              schemeType: 5,
            };
            // window.location.href = `${pdfObj.serverUrl}${pdfObj.linkUrl}`;
            window?.clp?.openAppUrl(JSON.stringify(jumpObj));
          } else {
            onHistoryPush('/pointshop/pointsH5', {
              product,
              userDimension,
              pageCode: effectivePbPageCode,
            });
          }
        }}
        style={{ marginTop: '0.24rem' }}
      >
        {btnText ||
          GCPI18n({
            id: 'lb_back_to_point_mall',
          })}
      </Button>
    </div>
  );
};

export default connect(({ index, pointShop }) => ({
  pbPageCode: pointShop.pbPageCode,
  product: index.product,
  userDimension: index.userDimension,
  dxpToken: index.dxpToken,
}))(SuccessPage);
